<script setup lang="ts">
import * as commonConstants from '@/constants/common';

export interface Props {
  color?: string;
}
const props = withDefaults(defineProps<Props>(), {
  color: undefined,
});
</script>

<template>
  <v-chip
    :rounded="0"
    data-testid="detailedJobChip"
    :class="$style.detailedJobChip"
    :color="props.color"
    size="small"
    variant="outlined"
  >
    <slot>{{ commonConstants.EM_DASH }}</slot>
  </v-chip>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.detailedJobChip {
  --v-chip-height: 22px !important;
  font-weight: 500 !important;

  :global {
    .v-chip__close {
      margin-inline-start: 5px !important;
      margin-inline-end: -1px !important;
    }
  }
}
</style>
